import React, { Component } from 'react'
import { Map, Marker, Popup, Tooltip, TileLayer } from 'react-leaflet'

export default class BlogMap extends Component {
  render() {
    const { options } = this.props
    if(options.position == null)
      return null
    if (typeof window !== 'undefined') {
      return (
      <Map center={options.position} zoom={13} style={{height:'300px'}}>
          <TileLayer
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            attribution="&copy; <a href=&quot;http://osm.org/copyright&quot;>OpenStreetMap</a> contributors"
            />
        <Marker position={options.position}>
          {options.permanent === true ? (
            <Tooltip permanent>{options.markertext}</Tooltip>
          ) : (
            <Popup>{options.markertext}</Popup>
          )}
        </Marker>
      </Map>
      )
    }
    return null
  }
}